<template>

    <div id="app" class="container" data-app>




        <div class="row">

          <div class="col-lg-8 mb-5 order-1 order-lg-1">

            <div class="d-block d-lg-none col-lg-4 mb-5 order-2 order-lg-2">



<!--               <p style="font-size:1.8rem;" class="anim-card text-center"> W Black Week obniżamy koszty! <br> Prowizja tylko 9.99%. <br> Skorzystaj z oferty.</p>

 -->

              <CalcSlider endpoint="" />

            </div>

            

            <div class="main-col ">

              <div class="container">
                    <div class="row">
                        <div class="col">



                          <div v-if="formErrors" class="col-12 alert alert-danger" >
                            <p>Niektóre pola formularza są niepoprawnie wprowadzone.</p>

                            <ul>
                              <li v-for="field in invalidFields" > {{ field }} </li>
                            </ul>
                          </div>


<!-- 
                          <p style="font-size:1.8rem;" class="anim-card text-center"> W Black Week obniżamy koszty! <br> Prowizja tylko 9.99%. <br> Skorzystaj z oferty.</p>


 -->


                            <!-- 1 STEP HEADER -->
                            <div v-if="activeStep == 1 && !formErrors">

                             <!--  <div class="row justify-content-between d-none d-md-flex">
                                <div class="col-auto me-auto">
                                  <h2>Mam już konto</h2>
                                </div>
                                <div class="col-auto">
                                  <a id="przycisk" class="login-button btn btn-outline-primary btn-lg me-2" data-bs-toggle="modal" data-bs-target="#loginDialog" @click="">Zaloguj się </a>
                                </div>
                              </div> 

                              <hr class=" d-none d-md-flex"/> -->



                              <div class="row mb-4  d-none d-md-flex">



                                


                                <div class="col-12 col-xl-auto me-auto">
                                  <h2>Rejestracja konta</h2>
                                </div>
                                <div class="col-12 col-xl-auto text-xl-end">
                                  <p>Jesteś nowym klientem?<br/>Prosimy o <b>wypełnienie danych poniżej</b>.</p>
                                </div>
                              </div>
                            </div> 




                            <!-- inputs -->
                            <div v-for="(item, idx) in stepForm" class="row">


                              <DynamicField

                                v-if="!String(idx).match(/^__row|__goto|__cmp|__endpoint|__wait|__amount/)"

                                :key="idx"
                                :name="idx"

                                :element="item"

                                :filled="isFilled"

                                :vuelidator="$v.form[ idx ]"

                                :form="form"
                              />

                              <DynamicField

                                v-if="String(idx).match(/^__row/)"

                                v-for="(element, name, index) in item"

                                :count="Object.keys(item).length"

                                :key="name"
                                :name="name"
                                :index="index"

                                :element="element"

                                :filled="isFilled"

                                :vuelidator="$v.form[ name ]"


                                :form="form"
                              />

                              <BlockTitle
                                v-if="String(idx).match(/^__cmp_BlockTitle/)"
                                :element="item"
                                :name="idx"
                              />


                            </div>




                            <!-- VERIFY CODE -->
                            <div class="row" v-if="String( specialStep ).match(/^verifycode/)" >


                              <div class="col-lg-12"><h3> Wprowadź kod SMS </h3></div>

                              <div class="col-lg-6 form-input">


                                <input type="text" class="form-control" placeholder="Kod SMS" v-mask="'NNNNNN'"  v-model="form['verifycode']" @input="$emit('input', $event.target.value); $v.form['verifycode'] && $v.form['verifycode'].$touch()"
                                       :class="{
                                            'is-valid': $v.form['verifycode'] && !$v.form['verifycode'].$invalid && $v.form['verifycode'].$dirty,
                                            'is-invalid': $v.form['verifycode'] && $v.form['verifycode'].$invalid && $v.form['verifycode'].$dirty
                                        }"
                                >

                                <div class="invalid-feedback" v-if="$v.form['verifycode'] && verifycode_hint && $v.form['verifycode'].$invalid && $v.form['verifycode'].$dirty">{{ verifycode_hint }}</div>

                              </div>
                            </div>




                            <!-- KONTOMATIK -->
                            <div class="row" v-show="String( specialStep ).match(/^kontox/)">
                              <div class="col-lg-12"><hr class="d-none d-md-flex"> <h3 style="padding: 1rem 0.5rem;"> Wybierz swoje główne konto abyśmy mogli je zweryfikować, na to konto wyślemy Ci Twoją pożyczkę. Pamiętaj aby było to Twoje główne konto na które przelewane jest np. Twoje Wynagrodzenie. Weryfikacja tego konta ma wpływ na Twoją zdolność kredytową. </h3></div>
                              <div id="kontox" class="column col-12 d-flex justify-content-center"></div>
                            </div>






                            <div class="row py-3 justify-content-end">


                              <div class="col-auto">

                                <a key="btn-prev"  v-if="activeStep > 1 && !String( specialStep ).match(/^kontox/) && !isFilled" class="button btn-prev btn btn-outline-primary btn-lg me-2" @click="prev" ><i class="icon flaticon-left-arrow"></i> COFNIJ </a>


                                <a  key="btn-filldbg"  v-if="debug && activeStep <= steps "
                                  class="button btn-prev btn btn-outline-primary btn-lg me-2"
                                  @click="filldebug" > DEBUG </a>


                                <a  key="btn-next"  v-if="activeStep <= steps && !String( specialStep ).match(/^kontox/)" :class="{
                                  disabled:$v.form.$invalid
                                }"
                                class="button btn-next  btn btn-outline-primary btn-lg me-2"
                                @click="next" > DALEJ <i class="icon flaticon-right-arrow"></i></a>





<!--
            <input type="button"  key="btn-axios" class="button btn-prev" @click="testroute" value="test" />

  -->




                              <!--  <a key="btn-submit"
                                          @click.prevent="onSubmit"
                                          type="submit"

                                          v-if="activeStep === steps"

                                          :disabled="$v.form.$invalid"

                                          class="form-button btn btn-outline-primary btn-lg me-2 "
                                  >WYŚLIJ <i class="icon flaticon-right-arrow"></i></a>
                                -->



                                </div>


                            </div>


                  </div>
                </div>
              </div>
            </div>


          </div>



          <div class="d-none d-lg-block col-lg-4 mb-5 order-2 order-lg-2">


            <CalcSlider  endpoint="" />
           

        </div>




        </div>

<!--
        <pre>
         {{ loanAmount }}
        </pre> -->


<!--         <pre>
         {{$v}}
        </pre> -->


<!--
        <pre>{{ form }}</pre>

  -->




    </div>
</template>

<script>

//import { validationMixin } from 'vuelidate';

import { url, alpha, email, required, minLength, maxLength, sameAs } from 'vuelidate/lib/validators';


import { validatePolish } from 'validate-polish';


import DynamicField from '@/components/DynamicField';
import BlockTitle from '@/components/BlockTitle';
import SignContract from '@/components/SignContract';
import CalcSlider from '@/CalcSlider';




export default {
  name: 'DynamicForm',
  components: { DynamicField, BlockTitle, SignContract, CalcSlider},


  data() {
    return {

      debug: false,

      page: null,
      fmap: null,

      fillDone: false,
      delayedTask: null,


      activeStep: 1,
      steps: 1,
      schema: [{}],

      verifycode_hint: '',

      formErrors: false,

      invalidFields: [],

      isFilled: false,

      // status calls
      waiting: '',
      waitCount: 0,


      editMode: 'persist',


      loanAmount: null,


      dynamicValidation: {},

      form: {

      }
    }
  },

  computed: {

    installmentAmount(){


      return (this.loanAmount / this.loanTenor).toFixed(2);
    },



    specialStep(){

      return this.schema[ this.activeStep-1 ].hasOwnProperty('__goto') ? this.schema[ this.activeStep-1 ].__goto : false;
    },


    stepForm() {


      this.activeStep == 1 && this.$router.currentRoute.path != '/'
        && this.$router.push({path: '/'});

      // set route
      this.activeStep > 1 && this.activeStep < 4
          && this.$router.push({path: ['quickform','verifycode','fullform','kontox'][this.activeStep-1]});



      if (this.schema[ this.activeStep-1 ].hasOwnProperty('__goto')) {

        return {};
      }


      return this.schema[ this.activeStep-1 ];
    },


    validationRules() {

      let rules = {},
          step =  this.schema[ this.activeStep-1 ],


          addValidation = (r, step, force=false) => {


            if (step.hasOwnProperty(r) && step[ r ].hasOwnProperty('vuelidation') && (!step[ r ].hasOwnProperty('hidden') || force)) {


              rules[ r ] = {};


              let def = step[r].vuelidation;


              for (let idx in def) {


                if (def.hasOwnProperty(idx)){


                  switch (idx) {

                    case 'required':

                      rules[r].required = required;
                      break;

                    case 'accepted':

                      rules[r].accepted = v => v === true;
                      break;

                    case 'email':

                      rules[r].email = email;
                      break;

                    case 'minLength':

                      rules[r].minLength = minLength(def[ idx ]);
                      break;

                    case 'maxLength':

                      rules[r].maxLength = maxLength(def[ idx ]);
                      break;

                    case 'sameAs':

                      rules[r].sameLike = sameAs(def[ idx ]);
                      break;

                    case 'alpha':

                      rules[r].alpha = alpha;
                      break;

                    case 'passwordPolicy':
                      rules[r].passwordPolicy = v => {
                      return this.passwordPolicy(v)
                      };
                      break;


                    case 'latin':
                      rules[r].latin = v => /[A-Za-z]/.test(v);
                      break;

                    case 'pesel': 
                      rules[r].pesel = validatePolish.pesel;
                      break;

                    case 'nip': 
                      rules[r].nip = validatePolish.nip;
                      break;

                    case 'idcard': 
                      rules[r].idcard = validatePolish.identityCard;
                      break;


  


                    default:
                  }
                }
              }
            }
          };




      // include dynamic fields
      //step = {...step, ...this.dynamicValidation};



      for (let r in step ) {

        if (String(r).match(/^__row/)) {

          for (let i in step[r]) {

            addValidation(i, step[r]);
          }

        }
        else {

          addValidation(r, step);
        }
      }


      // set dynamic validations
      Object.keys(this.dynamicValidation).map( k => {

        addValidation(k, this.dynamicValidation, true);
      } );


      if (this.specialStep == 'verifycode') {

        rules['verifycode'] = {
          minLength: minLength(4),
          maxLength: maxLength(4),
          required: required
        }
      }

      return rules;
    }
  },

  validations() {

    return {
      form: this.validationRules
    }
  },


  //
  //              METHODS
  //
  methods: {






    postKontoxData(kontoxData= null) {

       var page = this.$root.mainpage;


        if (!!kontoxData) {

          this.waiting = 'application';
          this.waitCount = 0;

          page.isLoading = 'to może potrwać do 5 minut..,prosimy o cierpliwość..,procesujemy Twój wniosek..'.split(',');

          this.post( '/bank', kontoxData)
          .then(response => {

            page.isLoading = !!this.waiting;

            if (!!response.data) {
              let ok = !(response.data.IS_ERROR | 0),
                  stage = response.data.stage || 'done';


              this.nextCB( ok, stage );
            }
          })
          .catch(error => {

              page.isLoading = false;

              // Error
              if (error.response) {
                  /*
                   * The request was made and the server responded with a
                   * status code that falls out of the range of 2xx
                   */
                  /*console.log(error.response.data);
                  console.log(error.response.status);
                  console.log(error.response.headers);*/

              } else if (error.request) {
                  /*
                   * The request was made but no response was received, `error.request`
                   * is an instance of XMLHttpRequest in the browser and an instance
                   * of http.ClientRequest in Node.js
                   */
                  //console.log(error.request);
              } else {
                  // Something happened in setting up the request and triggered an Error
                  //console.log('Error', error.message);
              }
          });
        }
    },



    verifyCode() {

       var page = this.$root.mainpage;


        //this.$v.form['verifycode'].$touch();

        if (String(this.form.verifycode).length > 0) {

          this.waiting = '';
          this.waitCount = 0;

          page.isLoading = true;



          this.post( '/activate', {

            client_email: this.form.client_email,
            activation_code: this.form.verifycode

          })
          .then(response => {

            page.isLoading = false;

            if (!!response.data) {

              let ok = !(response.data.IS_ERROR | 0);
              this.nextCB( ok );
            }


          })
          .catch(error => {
          //  console.log(error);


              page.isLoading = false;
              this.verifycode_hint = 'Wystąpił błąd.';

              // Error
              if (error.response) {
                  /*
                   * The request was made and the server responded with a
                   * status code that falls out of the range of 2xx
                   */
                  /*console.log(error.response.data);
                  console.log(error.response.status);
                  console.log(error.response.headers);*/

                  if (error.response.data.Message) {

                    this.verifycode_hint = error.response.data.Message.toString();
                  }
                  else if (error.response.data.MESSAGE) {

                    this.verifycode_hint = error.response.data.MESSAGE;
                  }


              } else if (error.request) {
                  /*
                   * The request was made but no response was received, `error.request`
                   * is an instance of XMLHttpRequest in the browser and an instance
                   * of http.ClientRequest in Node.js
                   */
                  //console.log(error.request);
              } else {
                  // Something happened in setting up the request and triggered an Error
                  //console.log('Error', error.message);
              }


              this.form['verifycode'] = '';
              this.$v.form['verifycode'].$touch();

            //console.log('Network error', error);

          });
        }
    },



    onSubmit( endpoint='application' ) {


      var page = this.$root.mainpage,
        result = false;


      // set polling endpoint after main request complete
      this.waiting = this.stepForm.hasOwnProperty('__wait') ? this.stepForm.__wait : '';
      this.waitCount = 0;``
      this.formErrors = false;

      // enable page loading mask
      page.isLoading = 'to może potrwać 1 minutę..,prosimy o chwilę cierpliwości..'.split(','); //true;


//console.log(this.form);


      let r, r2, basic = this.getConf('basicSubmitParams'),

      form = {},

      consents = {},

      custom = {},

      params;


//console.log(this.form);

      for (let e in this.form) {

        if (this.form.hasOwnProperty(e)) {
          if (typeof this.form[e] == 'object') {
            if (this.form[e].hasOwnProperty('value')) {

              form[e] = this.form[e].value;
            }
          }
          else {


            r = String(e).match(/consent([0-9]+)/);
            r2 = String(e).match(/custom-([0-9]+)/);


            if ( r && r.length > 1) {


              consents[ r[1] ] = 1;
            }
            else if (r2 && r2.length > 1) {

              custom[ r2[1] ] = this.form[e];
            }
            else {

              form[e] = this.form[e];
            }
          }
        }
      }


      // convert to json string
      custom = JSON.stringify(custom);


      params = {...basic, ...form, client_consents: consents, custom_fields: custom};


      if (page.loggedIn) {

        params['client_id'] = page.loggedIn.client_id;
      }


      // clean spaces from nrb field
      //params.client_bank_account && (params.client_bank_account =  params.client_bank_account.split(' ').join(''));



      // clean cellphone
      params.client_cellphone && (params.client_cellphone = params.client_cellphone.split('-').join(''));

      // loan amount
      params.requested_amount = this.loanAmount;

      // loan installments
      params.requested_installments = this.loanTenor;



      this.post( '/' + endpoint, params )
            .then(response => {

              page.isLoading = !!this.waiting;

              let ok = !(response.data.IS_ERROR | 0),
                  stage = response.data.stage || 'done';


              response.data.hasOwnProperty('Message')
                  && (this.form.loan_id = response.data.Message);


              this.nextCB( ok, stage );

            })
            .catch(error => {

              page.isLoading = false;

              let err = error.response.data.Message;

              if (err) {

                this.pageTop();

                this.formErrors = true;

                this.invalidFields = [];


                for (let bind in err) {


                  if (err.hasOwnProperty(bind)) {

                    this.echo('invalid_field', bind, err[ bind ].join(', '));


                    // if some field in error is not present on the form
                    //!this.form.hasOwnProperty( bind ) && 
                    this.invalidFields.push( bind );
                  }
                }

                //this.verifycode_hint = error.response.data.Message.toString();

              }
              else {
                err = error.response.data;

                if (err.hasOwnProperty('PAYLOAD') && String(err.PAYLOAD).match(/do panelu/)){

                  // login to client account info
                  this.echo('next_step_fail');  
                }

              
                /*console.log("to tutaj");*/
               // 
              //console.log('Network error', error);

              }

     
            });



            return result;



 //     console.log('Submit clicked');
    },



    onWaiting( endpoint='application' ) {


      var page = this.$root.mainpage,
          step,


        poll = () => {

          // 3 sek * 120 = 6 min
          if (this.waitCount > 120){

            page.isLoading =false;

            // timeout page
            this.routeToStage('pending');
            return;
          }

          this.waitCount++;



          this.get( '/' + endpoint )
              .then(response => {


                if (!!response.data) {

                  step = response.data.hasOwnProperty('step') ? response.data.step : '';

//console.log(step);

                  switch (step) {

                    case 'wait':
                      break;

                    case 'reject':
                      page.isLoading=false;
                      this.routeToStage('reject');
                      return;

                    case 'kontox':

                      page.isLoading =false;

                      this.doNextStep('kontox');
                      return;

                    case 'counteroffer':
                      page.isLoading =false;
                      this.routeToStage('proposal', response.data);
                      return;

                    case 'not defined':
                      //console.log('not definedd');

                      page.isLoading =false;
                      this.nextCB( true, 'pending' );
                      return;

                    case 'authologic_start':
                      page.isLoading=false;
                      window.location = response.data.step_details;
                      return;

                    case 'easycheck':
                      page.isLoading=false;
                      window.location = response.data.step_details;
                      return;

                      

                    default:
                      page.isLoading =false;
                      this.nextCB( true );
                      return;
                  }

                }
                else {

                  console.log('status reutrned an empty response')
                }


                // dispatch another poll request
                page.isLoading
                    && setTimeout(poll, 3000);


              })
              .catch(error => {


                  // wait fot timeout insted
                  //page.isLoading = false;
                  setTimeout(poll, 3000);

                  // Error
                  if (error.response) {


                  } else if (error.request) {

                  } else {
                      // Something happened in setting up the request and triggered an Error
                      //console.log('Error', error.message);
                  }
              });


        };


        // initial polling
        setTimeout(poll, 3000);
    },



    routeToStage(stage='thankyou', data=null) {


      switch (stage) {

        case 'done':
          this.$router.push({path: 'thankyou'});
          break;


        case 'pending':
          this.$router.push({path: 'pending'});
          break;

        case 'step_details':
          this.$router.push({path:'step_details'});
          break;


        case 'proposal':

          this.finishDate = data.last_installment_date.split(' ')[0].replace(/([0-9]{4})-([0-9]{2})-([0-9]{2})/, '$3.$2.$1');
          //this.setValues(data.net_amount);

          this.setValues(parseInt(data.net_amount), this.getConf('default_tenor'), this.getConf('tenor_sign') );


          this.$router.push({path: 'proposal'})
                .then(  () => {

                  //bus.$emit('proposal_amount', data);

                })
                .catch(() => {});

          break;


        case 'reject':
          this.$router.push({path: 'rej'});
          break




        default:

          this.$router.push({path: 'thankyou'});
      }
    },





    filldebug($ev) {

        this.echo('filldebug');
    },


    // next callback
    nextCB(result=false, stage='done') {

      var page = this.$root.mainpage;

      if (!page.isLoading) {
        this.waiting = false;
        this.waitCount = 0;
      }

      // bad request
      if (!result){
        //error message here
        return;
      }



      if (!this.waiting) {

        if (this.activeStep < this.steps) {

          this.doNextStep();
        }
        else {

          this.routeToStage( stage );
        }
      }
      else {

        this.onWaiting( this.waiting );
      }

    },


    next($ev) {

//console.log(this.stepForm);


      // CURRENT STEP
      // chcek if current step is posting data

      if (this.stepForm.hasOwnProperty('__endpoint')) {






        this.onSubmit(this.stepForm.__endpoint.trim());

        // above async so return so far, continue with callback
        return;

      }

      else if (this.specialStep == 'verifycode') {

        this.verifyCode();

        // above async so return so far, continue with callback
        return;
      }
      // END CURRENT STEP



      this.doNextStep();


    },


    doNextStep(goto=''){


      if (!!goto) {

        let stage = ['quickform','verifycode','fullform','kontox'].indexOf( goto );


        if (stage > -1) {

          this.activeStep = stage;
        }
        else {
          let as = 0;
          this.schema.map( s => {

            if (s.hasOwnProperty('__goto')) {

              if (s.__goto == goto) {

                this.activeStep = as;
              }
            }

            as++;
          });
        }
      }



      // GO TO NEXT STEP
      if (this.schema[this.activeStep]) {

        let step = this.schema[this.activeStep];



        if (step.hasOwnProperty('__goto')) {

            switch (step.__goto) {

              case 'kontox':


                //this.$router.push({path: 'kontox'});
                // index.js
                embedKontomatik({
                  client: this.getConf('kontomatikClient' + (this.debug ? 'Test' : '')),  // replace it with your assigned client id
                  divId: 'kontox',       // must match the div element id
                  locale: 'pl',       // ui language
                  onSuccess: (target, sessionId, sessionIdSignature, options) => {
                    // End-user successfully signed in to the bank
                    // Pass target, sessionId and sessionIdSignature to your backend
                    //alert('It works!');

                    this.postKontoxData({
                      "session_id": sessionId,
                      "session_id_signature": sessionIdSignature,
                      "internet_loan_request_id": this.form.loan_id
                    });
                  }
                });

                break;

            }


            // scroll to top with .5s delay
            this.pageTop();
        }

        //else {

  //console.log($ev)

          this.activeStep++;
        //}
      }
    },





    prev() {

      this.activeStep--;


    },


    testroute() {



/*

let dt = {"status_name":"Kontroferta","color":"blue","icon":"thumbs-up","step":"counteroffer","net_amount":"1000.0000","gross_amount":".00","interest_amount":"6.0000","loan_date":"2021-09-26 00:00:00.000","last_installment_date":"2021-10-26 00:00:00.000","lead_id":"1006","loan_id":"517","client_id":"360","status_id":".40","pay_out_type":"1","reject_reason":null,"contract_nbr":" UM-353\/09\/2021","agent_id":"2","installments_nbr":"1","installment_amount":"1280.00","initial_payment":"0","insurance_amount":".0000","service_fee":".0000","loan_status_date":"2021-09-26 16:03:48.077"};




this.routeToStage('proposal', dt);


*/

      //console.log(this.$root);


     // let page = this.$root.mainpage;



//window.scrollTo(0,0)


//document.documentElement.style.overflow = 'hidden';


/*var del = document.documentElement,

top = del.scrollTop;



console.log(top);


window.addEventListener('scroll',  function(){

console.log(top)
 // del.scrollTop = top;


  window.scrollTo(0, top);


}, false);
*/






//document.body.style.overflow='hidden';

//console.log(document)




/*
      this.$router.push({path: '/proposal'})
      .then(  () => {


        bus.$emit('proposal_amount', 950);

      })
      .catch(() => {});


*/

      this.page.isLoading = true;

      /*setTimeout(() => {



        nau.isLoading = false


        this.$router.push({path: 'kontox'});


      }, 3000)*/



    },



    fillUp(item){


//console.log('fill item ' + item);



      return this.fmap.hasOwnProperty(item) && this.echo('fill_up', item, this.page.loggedIn[ this.fmap[item] ]) || this.page.loggedIn.hasOwnProperty(item) && this.echo('fill_up', item, this.page.loggedIn[ item ]);
    },



    fillForm(){

      if (!this.page.loggedIn) {
        return;
      }

      this.delayedTask = null;


      Object.keys(this.stepForm).map( k => {

        if (k.match(/^__row/)) {

          Object.keys(this.stepForm[k]).map( sk => {


            this.fillUp(sk);
          });
        }
        else {
          this.fillUp(k);
        }
      });


      // special fill ups - second address, consents, polish citizen check
      this.echo('fill_up', 'country', 1);



      // saved model from 1st step
      this.form = {...this.form,


        client_name: this.page.loggedIn['name'],
        client_surname: this.page.loggedIn['surname'],
        client_email: this.page.loggedIn['email'],
        client_cellphone: this.page.loggedIn['cellphone'],
        client_PESEL: this.page.loggedIn['pesel'],
      };



      this.fillDone = true;
    }



  },



  created() {

    this.page = this.$root.mainpage;

    this.fmap = {
        client_name:                        'name',
        client_surname:                     'surname',
        client_identity_card:               'identity_card',
        client_identity_card_expiry_date:   'identity_card_expiry_date',
        client_address1_street:             'street1',
        client_address1_city:               'city1',
        client_address1_flat_nbr:           'flat1',
        client_address1_building:           'building1',
        client_address1_postal_code:        'postal_code1',
        client_address2_street:             'street2',
        client_address2_city:               'city2',
        client_address2_flat:               'flat2',
        client_address2_building:           'building2',
        client_address2_postal_code:        'postal_code2',
        client_education:                   'education_type_id',
        client_civil_state:                 'civil_state_id',
        client_employment_type:             'income_type_id',
        client_employer_name:               'company_name'
     

      };


   // console.log(__CFG)


   let uri = window.location.href.split('?');

   //console.log(uri);


   if (uri.length > 1 && /amount=[0-9]+/.test(uri[1]) ) {


      let reg = uri[1].match(/amount=([0-9]+)/);

      this.loanAmount = reg[1];
   }



    // initial amount set
    this.setValues(this.loanAmount, this.getConf('default_tenor'), this.getConf('tenor_sign'));




//console.log('fees as folows  ' + this.service + ' ' + this.interest);


    this.listen('calc_edit_done', () => {


      if (this.editMode !== 'persist') {

        this.editMode = false;
      }
    });


    // dynamic validations
    this.listen('dynamic_validation', (bind, enabled) => {


      // remove if not set
      if (!enabled && this.dynamicValidation.hasOwnProperty(bind)){

        delete this.dynamicValidation[ bind ];
      }

      // iterate current form
      Object.keys(this.stepForm).map( k => {
        if (k.match(/^__row/)) {
          Object.keys(this.stepForm[k]).map( sk => {

            sk == bind && !!enabled
              && (this.dynamicValidation[ sk ] = this.stepForm[k][sk]);
          });
        }
        else {

          k == bind && enabled
            && (this.dynamicValidation[ k ] = this.stepForm[k]);
        }
      });


      // force vue to re-apply validations
      this.dynamicValidation = {...this.dynamicValidation};

    });




    // client session id for quicksave and full form
    if (!this.page.uuid) {

      //this.page.uuid = window.__sid || uuidv4();   

      // new session every time, cause different users can use the same device
      this.page.uuid = uuidv4();      
    }



    // client session id for quicksave and full form
    this.form['external_id'] = this.page.uuid



    this.get( '/config' + (!uri[1] ? '' : '?' + uri[1]), null, {
          baseURL: this.getConf('secondaryEndpoint')
        } )
        .then(response => {

          this.schema = response.data;
          this.steps = this.schema.length;


          this.debug = this.schema.length > 0 && this.schema[0].hasOwnProperty('__endpoint') && this.schema[0].__endpoint[0] == ' ';


          // default amount
          if (this.schema.length > 0 && this.schema[0].hasOwnProperty('__amount') && !String(uri[1]).match(/amount/) ) {

            this.setValues(this.schema[0].__amount, this.getConf('default_tenor'), this.getConf('tenor_sign'));

          }


          this.isFilled = this.page.loggedIn && this.steps > 0;

        })
        .catch(error => {
          console.log('Network error', error);
        });


  },


  mounted() {



  },



  updated() {



    // logged in so redirect to fullform
    if (this.activeStep == 1 && this.steps > 0 && this.page.loggedIn) {

      this.doNextStep('fullform');
    }


    // go to fullform step and fill data
    if (this.page.loggedIn && typeof this.page.loggedIn == 'object' && this.steps > 0 && !this.fillDone ) {


      if (this.delayedTask) {

        this.delayedTask = clearTimeout(this.delayedTask);
      }


      this.delayedTask = setTimeout(this.fillForm, 800);

    }



  }
}
</script>


<style >

#form-wrapper h2 {
  font-size: 2rem;
}


ul.form-steps {
  list-style: none;
  display:flex;
  justify-content: center;

  margin-bottom:2rem;
}

ul.form-steps li {
  display: list-item;
  width: 2rem;
  height: 2rem;
  line-height: 2rem;
  border-radius: 100%;
  background: #d8d8d8;
  margin-right: 3rem;
  position: relative;
  font-size:.9rem;
  text-align:center;
}

ul.form-steps li:last-child {

  margin-right:0;
}

ul.form-steps li:first-child {
  margin-left: unset;
}

ul.form-steps li:first-child:before {
  display: none;
}

ul.form-steps li:before {
  content: "";
  width: 3rem;
  background-color: #d8d8d8;
  height: 2px;
  position: absolute;
  top: 1rem;
  right: 1.9rem;
}

ul.form-steps .active {
  background: #0bc268;
  color: #fff;
}

ul.form-steps .active:before {
  background-color: #0bc268;
}


.form-btn-wrap {

  margin-top: .5rem;
  padding: 2rem 1rem;

  display: flex;
  justify-content:flex-end;
}

.main-form .button {

    cursor:pointer;
    min-width:260px;
    font-size: 16px;
    padding: 16px 40px;
    transition: ease-out 1s;
    line-height: 16px;

    border-radius:10px;
    border:0px;

    margin: 0 .5rem;

}

.main-form .button:disabled {
  cursor:not-allowed;
  opacity: .7;
}


.form-button.btn.disabled {
  background-color: #045439;
}


.main-form .button.btn-next, .main-form .button.btn-submit {

  background-color: #0bc268;
  color: #fff;
}

.main-form .button.btn-next:hover, .main-form .button.btn-submit:hover {
  box-shadow: inset -400px 0 0 0 #007666;
}


.main-form .button.btn-prev {

  background-color: #dfdfdf;
  color: rgb(64, 64, 64);
}

.main-form .button.btn-prev:hover {
  box-shadow: inset -400px 0 0 0 #bebebe;
}


.main-form .form-input {

  transition: all 0.2s ease-in-out;
  border-radius:10px;
  min-height: 30px;
  padding:10px;
  color: #404040;
  border: 1px solid #ccc;
  font-weight:600;
  font-size:16px;
  height:auto;
}

.main-form .form-input:focus {
  -webkit-box-shadow: 0 12px 30px rgba(0,0,0,.07);
  box-shadow: 0 12px 30px rgba(0,0,0,.07);
}








.button {

    cursor:pointer;
    min-width:220px;
    font-size: 16px;
    padding: 16px 40px;
    transition: ease-out 1s;
    line-height: 16px;

    border-radius:10px !important;
    border:0px;

    margin: 0 .5rem;

}

.button.disabled {
  cursor:not-allowed;
  opacity: .7;
}

.button.btn-prev {

  background-color: #dfdfdf;
  color: rgb(64, 64, 64);
}

.button.btn-prev:hover {
  box-shadow: inset -400px 0 0 0 #bebebe;
}



.button.btn-next, .button.btn-submit, .button.btn-next.disabled {

  background-color: #0bc268 !important;
  color: #fff;
}

.button.btn-next:hover, .button.btn-submit:hover {
  box-shadow: inset -400px 0 0 0 #007666;
}


</style>



// WEBPACK FOOTER //
// src/DynamicForm.vue